import {createContext, useContext} from 'react'
import PropTypes from 'prop-types'
import {useSimpleQuery} from '@frnt/base/hooks'
import {ResourceApiServiceProvider} from '../resource-api-service-provider'
import qs from 'qs'

const FinancialReportsServiceContext = createContext(undefined)

const FinancialReportsServiceProvider = ({
  children,
  baseApiHost,
  handleUnauthorized = () => {
    // Do nothing
  }
}) => {
  return (
    <ResourceApiServiceProvider
      Context={FinancialReportsServiceContext}
      handleUnauthorized={handleUnauthorized}
      host={baseApiHost}
      valueCallback={(axios) => ({
        create: async (payload) => {
          const {data} = await axios.post(`/api/v1/content/financial_reports`, payload)
          return data
        },
        get: async (id) => {
          const {data} = await axios.get(`/api/v1/content/financial_reports/${id}`)
          return data
        },
        list: async (query) => {
          const {data} = await axios.get(
            `/api/v1/content/financial_reports${qs.stringify(query, {
              addQueryPrefix: true
            })}`
          )
          return data
        },
        update: async (id, payload) => {
          const {data} = await axios.patch(`/api/v1/content/financial_reports/${id}`, payload)
          return data
        },
        delete: async (id) => {
          const {data} = await axios.delete(`/api/v1/content/financial_reports/${id}`)
          return data
        }
      })}>
      {children}
    </ResourceApiServiceProvider>
  )
}

FinancialReportsServiceProvider.propTypes = {
  children: PropTypes.any,
  baseApiHost: PropTypes.string.isRequired,
  handleUnauthorized: PropTypes.func
}

const useFinancialReportsService = () => {
  const context = useContext(FinancialReportsServiceContext)
  if (context === undefined) {
    throw new Error('FinancialReportsServiceContext was not provided. Make sure your component is a child of the FinancialReportsServiceProvider.')
  }
  return context
}

const useFinancialReportsQuery = ({query, ...otherProps}) => {
  const financialReportsService = useFinancialReportsService()
  return useSimpleQuery({
    queryKey: `financial_reports-list-${JSON.stringify(query)}`,
    queryFn: async () => financialReportsService.list(query),
    ...otherProps
  })
}

const useFinancialReportQuery = ({id, enabled, ...otherProps}) => {
  const financialReportsService = useFinancialReportsService()
  return useSimpleQuery({
    queryKey: `financial_reports-get-${id}`,
    queryFn: async () => financialReportsService.get(id),
    enabled: enabled !== undefined ? enabled : !!id,
    ...otherProps
  })
}

export {FinancialReportsServiceProvider, useFinancialReportsService, useFinancialReportsQuery, useFinancialReportQuery}
